import {GET_LANGUAGES, GET_ABOUT_CONTENT} from './actionTypes'

const initialState = {
  langs: '',
  // isLoading: false,
  // hasError: false,
  fulfilledLangs: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LANGUAGES:
      return {
        ...state,
        langs: action.payload.data,
        fulfilledLangs: true,
      }

    default:
      return state
  }
}

const initState = {
  content: '',
  fulfilledContent: false,
}

export const ContentReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_ABOUT_CONTENT:
      return {
        ...state,
        content: action.payload.data,
        fulfilledContent: true,
      }

    default:
      return state
  }
}
